module.exports = __webpack_public_path__ + "4f0ccb18601efe00eb6d3f1063570003.pdf";